
import { defineComponent } from "vue";
import RoundButton from "@/components/buttons/RoundButton.vue";

interface Props {
    arEnabled: boolean;
}

export default defineComponent<Props>({
    name: "StandardProjectSuccess",
    components: {
        RoundButton
    }
});
